import "@conectate/components/ct-icon.js";

import { CtLit, css, html, property } from "@conectate/components/ct-lit";
import { icon } from "@conectate/components/icon-list";

class CtItem extends CtLit {
	//https://web.whatsapp.com/send?phone=502595959
	//https://wa.me/502595995
	//tel:

	static styles = css`
		:host {
			display: block;
			position: relative;
			outline: none;
			cursor: pointer;
			color: var(--color-on-surface, #000);
			/* padding: 8px 16px; */
		}

		.body {
			display: flex;
			position: relative;
			flex-direction: row;
			align-items: center;
			user-select: none;
			padding: 8px 16px;
		}

		.name {
			display: flex;
			align-items: center;
			flex: 1;
			white-space: pre-wrap;
			word-wrap: break-word;
			font-size: 0.9em;
			padding: 4px 0;
		}

		ct-icon {
			margin-right: 16px;
		}

		a {
			color: inherit;
		}
		.cont,
		.noti {
			padding: 4px;
			background: var(--c2-grad-orange);
			box-shadow: var(--c2-shadow-red);
			color: #fff;
			border-radius: var(--border-radius, 16px);
			min-width: 16px;
			height: 16px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-weight: bold;
		}
		.sep {
			margin: 0 0 0 16px;
			height: 1px;
			background: var(--color-outline);
		}
		.sep2 {
			margin: 0 0 0 56px;
			height: 1px;
			background: var(--color-outline);
		}
		:host(:last-child) .sep2,
		:host(:last-child) .sep,
		:host([data-last]) .sep,
		:host([data-last]) .sep2 {
			height: 0;
		}
	`;
	render() {
		return html`
			<div class="body">
				${this.icon ? html` <ct-icon .svg=${this.icon}></ct-icon> ` : ""} ${this.ic ? html` <ct-icon icon=${this.ic}></ct-icon> ` : ""}
				<div class="name">${this.link ? html` <a href="${this.link}">${this.text}</a> ` : this.text}<slot></slot></div>
				${this.cont ? html` <div class="cont">${this.cont > 9 ? html`9<sup>+</sup>` : this.cont}</div> ` : ""}
			</div>
			<div class="sep${this.icon ? "2" : ""}"></div>
		`;
	}

	@property({ type: String }) icon = "";
	@property({ type: String }) ic!: icon;
	@property({ type: Number }) cont = 0;
	@property({ type: String }) text = "";
	@property({ type: String }) link = "";
}

window.customElements.define("ct-item", CtItem);
